<template>
  <div 
    v-if="shouldShow" 
    class="validation-details-section">
    <div class="section-header">
      <svg 
        class="section-icon red-icon" 
        width="20" 
        height="20" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2" 
        viewBox="0 0 24 24">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
        <polyline points="22,4 12,14.01 9,11.01"/>
      </svg>
      <h3>Validation Details</h3>
    </div>
    <div class="validation-grid">
      <div class="validation-item">
        <label class="validation-label">Validation Date & Time</label>
        <p class="validation-value">{{ validationDate }}</p>
      </div>
      <div class="validation-item">
        <label class="validation-label">LDHN Unique Identifier</label>
        <a 
          v-if="validationLink" 
          :href="validationLink" 
          target="_blank" 
          class="lhdn-link">
          {{ uniqueIdentifier || '-' }}
        </a>
        <p 
          v-else 
          class="validation-value">{{ uniqueIdentifier || '-' }}</p>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
    name: 'ValidationDetailsSection',
    props: {
        alreadySubmitted: {
            type: Boolean,
            required: true,
        },
        isExpired: {
            type: Boolean,
            required: true,
        },
        status: {
            type: String,
            default: 'Submitted',
        },
        validationDate: {
            type: String,
            required: true,
        },
        uniqueIdentifier: {
            type: String,
            default: '',
        },
        validationLink: {
            type: String,
            default: '',
        },
    },
    computed: {
        shouldShow() {
            return (
                this.alreadySubmitted &&
                !this.isExpired &&
                this.status === 'Valid'
            );
        },
    },
};
</script>
  
  <style scoped>
.validation-details-section {
    background: #f0fdf4;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
    overflow: hidden;
    border: 1px solid #bbf7d0;
}

.section-header {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    background: #dcfce7;
    border-bottom: 1px solid #bbf7d0;
}

.section-icon {
    color: #ef5350;
    margin-right: 12px;
    flex-shrink: 0;
}

.section-header h3 {
    font-size: 1.125rem;
    font-weight: 600;
    color: #1e293b;
    margin: 0;
}

.validation-grid {
    padding: 24px;
    display: grid;
    gap: 20px;
}

.validation-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.validation-label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
    margin: 0;
}

.validation-value {
    font-size: 1rem;
    color: #1e293b;
    margin: 0;
    padding: 8px 0;
}

.lhdn-link {
    font-size: 1rem;
    color: #3b82f6;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
    padding: 8px 0;
    display: block;
}
.lhdn-link:hover {
    color: #2563eb;
}

@media (min-width: 768px) {
    .validation-grid {
        grid-template-columns: 1fr 1fr;
    }
}

@media (max-width: 768px) {
    .section-header {
        padding: 16px 20px;
    }
    .validation-grid {
        padding: 20px;
        gap: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/e-invoice/portal/components/ValidationDetailsSection.vue